module.exports = __webpack_public_path__ + "img/pager8img.6600ffe7.jpg";